import React from 'react';
import styles from './styles/totalBar.scss';

const ValuesList = props => {

    const {children} = props;

    
    return (
        <div className="lista valores">
            {children}
        </div>
    );
};

export {ValuesList};